import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouterPreloaderService } from '@app/core/services';
import {
  AuthGuard,
  UserAccessGuard,
  NonAuthGuard,
  MaintenanceGuard,
  NonMaintenanceGuard,
} from '@app/core/guards';

const routes: Routes = [
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./modules/maintenance-splash/maintenance-splash.module').then(
        (m) => m.MaintenanceSplashModule,
      ),
    canActivate: [MaintenanceGuard],
  },
  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  {
    path: 'signout',
    loadChildren: () =>
      import('./modules/signout/signout.module').then(
        (m) => m.SignOutPageModule,
      ),
    canActivate: [NonAuthGuard, NonMaintenanceGuard],
  },
  {
    path: 'signin',
    loadChildren: () =>
      import('./modules/signin/signin.module').then((m) => m.SigninPageModule),
    canActivate: [NonAuthGuard, NonMaintenanceGuard],
  },
  {
    path: 'update',
    loadChildren: () =>
      import('./modules/update-version/update-version.module').then(
        (m) => m.UpdateVersionModule,
      ),
    canActivate: [NonMaintenanceGuard],
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./modules/privacy/privacy.module').then(
        (m) => m.PrivacyPageModule,
      ),
    canActivate: [NonMaintenanceGuard],
  },
  {
    path: 'tou',
    loadChildren: () =>
      import('./modules/tou/tou.module').then((m) => m.TouPageModule),
    canActivate: [NonMaintenanceGuard],
  },
  {
    path: 'restricted',
    loadChildren: () =>
      import('./modules/restricted-access/restricted-access.module').then(
        (m) => m.RestrictedAccessModule,
      ),
    canActivate: [NonMaintenanceGuard],
  },
  {
    path: 'reset',
    loadChildren: () =>
      import('./modules/password-reset/password-reset.module').then(
        (m) => m.PasswordResetPageModule,
      ),
    data: { preload: true },
    canActivate: [NonAuthGuard, NonMaintenanceGuard],
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import(
        './modules/password-reset/email-confirmation/email-confirmation.module'
      ).then((m) => m.EmailConfirmationPageModule),
    canActivate: [NonAuthGuard, NonMaintenanceGuard],
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./modules/features/features.module').then(
        (m) => m.FeaturesModule,
      ),
    canActivate: [AuthGuard, NonMaintenanceGuard],
    canActivateChild: [UserAccessGuard],
    data: {
      skipLocationChange: true,
      preload: true,
    },
  },
  { path: '**', redirectTo: 'signin', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: RouterPreloaderService,
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
